export default __webpack_public_path__ + "static/media/car.bafc1d0b.png";